exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".wrapper{background-color:#fff;padding:8px;border-radius:6px;display:flex;flex-direction:column;width:100%;margin-inline:auto}.label-count{display:flex;flex-direction:row;justify-content:center;gap:14px}.timer-counter{color:#722ed1;font-weight:bold}.title-counter-big{font-weight:bold;width:100%;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.timer-desc-counter-big{color:#4c4d66;font-size:12px;margin-block:8px}", ""]);

// exports
